export const actionGalleryXml = () => {
  const processImage = `
  <action name="processed_image" type="Javascript"><![CDATA[
    (async function() {
      const currentPanoId = krHooks.getCurrentPanoramaId();
      if (krHooks.getImageInfos().has(currentPanoId) === false) {
        await krHooks.setMarkerImageInfos();
      }
    })();
  ]]></action>

  <action name="resize_image_to_fit_contain" type="Javascript"><![CDATA[
    const currentPanoId = krHooks.getCurrentPanoramaId();
    const currentObjectId = args[1];
    const bgWidth = Number(args[2]);
    const bgHeight = Number(args[3]);
    const currentImageInfo = krHooks.getImageInfos().get(currentPanoId).get(currentObjectId);
    const imgRatio = (currentImageInfo.width / currentImageInfo.height).toFixed(2);
    const bgRatio = (bgWidth / bgHeight).toFixed(2);

    const resizeImage = { width: 0, height: 0 };
    if (imgRatio > bgRatio) {
      // If the image is wider, scale it according to the container width
      resizeImage.width = bgWidth
      resizeImage.height = (bgWidth / imgRatio).toFixed(2)
    } else {
      // If the image is taller, scale it according to the container height
      resizeImage.width = (bgHeight / imgRatio).toFixed(2)
      resizeImage.height = bgHeight
    }
    krpano.set("galleryImageWidth", resizeImage.width);
    krpano.set("galleryImageHeight", resizeImage.height);
  ]]></action>
  `

  const setScaleAndHtmlXml = `
    <action name="set_webXR_marker_gallery_scale_html" scope="local">
      set_marker_scale_html('markerInfoBg', 1, null);
      set_marker_scale_html('markerCloseButton', 1, null);
      set_marker_scale_html('markerFavoriteButton', 1, null);
      ${setGalleryScaleXml}
    </action>
  `
  const setPositionXml = `
    <action name="set_webXR_marker_gallery_position" scope="local" args="ath, atv">
      set_marker_position('markerInfoBg', get(ath), get(atv));
      set_marker_position('markerCloseButton', get(ath), get(atv));
      set_marker_position('markerFavoriteButton', get(ath), get(atv));
      ${setGalleryPositionXml}
    </action>
  `
  const setSizeXml = `
    <action name="set_webXR_marker_gallery_size" scope="local">
      <!-- bg -->
      set(local.bg_width, get(galleryBgWidth));
      set(local.bg_height, get(galleryBgHeight));
      <!-- photo -->
      resize_image_to_fit_contain(get(currentObjectId), get(bg_width), get(bg_height));
      txtadd(markerPhoto, 'markerInfoImage_0_', get(currentObjectId));
      set(local.photo_width, get(galleryImageWidth));
      set(local.photo_height, get(galleryImageHeight));

      set_marker_size(get(markerPhoto), get(photo_width), get(photo_height));
      set_marker_size('markerInfoBg', get(bg_width), get(bg_height));
    </action>
  `
  const defineOffsetXml = `
    <!-- start position -->
    set(start_ox, calc(0 - (get(galleryBgWidth) / 2)));
    set(start_oy, calc(0 - (get(galleryBgHeight) / 2)));
    <!-- close & favorite button -->
    def(btn_mt, number, 35);
    set(close_ox, calc(start_ox + 700));
    set(close_oy, calc(start_oy + btn_mt));
    set(favorite_ox, calc(start_ox + 617));
    set(favorite_oy, calc(start_oy + btn_mt));
    <!-- scale up & down button -->
    set(scaleUp_ox, calc(start_ox + 700));
    set(scaleUp_oy, calc(start_oy + 418));
    set(scaleDown_ox, calc(start_ox + 700));
    set(scaleDown_oy, calc(start_oy + 502));
  `
  const setOffsetResultXml = `
  <!-- close button -->
    set_marker_offset('markerCloseButton', get(close_ox), get(close_oy));
    set_marker_offset('markerFavoriteButton', get(favorite_ox), get(favorite_oy));
    txtadd(markerName, 'markerScaleUp_', get(currentObjectId));
    set_marker_offset(get(markerName), get(scaleUp_ox), get(scaleUp_oy));
    txtadd(markerName, 'markerScaleDown_', get(currentObjectId));
    set_marker_offset(get(markerName), get(scaleDown_ox), get(scaleDown_oy));
  `
  const setOffsetXml = `
    <action name="set_webXR_marker_gallery_offset" scope="local">
      ${defineOffsetXml}
      ${setOffsetResultXml}
    </action>
  `
  return `
    ${processImage}
    ${setScaleAndHtmlXml}
    ${setPositionXml}
    ${setSizeXml}
    ${setOffsetXml}
  `
}

export const setCurrentGalleryVariableXml = `
  <action name="ini_webXR_gallery_variable">
    def(imagesLength, number,%1);
    set(haveGallery, calc(imagesLength GE 1));
    set(haveMultiImages, calc(imagesLength GT 1));
    def(currentGalleryIndex, number, 0);
    def(currentImageScale, number, 1);
    def(notFirstImage, boolean, false);
    def(notLastImage, boolean, false);
    def(notLargestScale, boolean, false);
    def(notSmallestScale, boolean, false);
    def(maxScale, number, 1.4);
    def(minScale, number, 0.2);
    def(scaleGap, number, 0.4);
    def(enableClickButton, boolean, true);
    def(galleryBgWidth, number, 800);
    def(galleryBgHeight, number, 600);
    def(galleryImageWidth, number, 800);
    def(galleryImageHeight, number, 600);
  </action>
`

export const setGalleryButtonsImgXml = `
  <action name="set_webXR_gallery_buttons_img">
    if (haveMultiImages,
      txtadd(markerName, 'markerNext_', get(currentObjectId));
      replace_marker_url(%markerName, ${require('../img/button/right-default.png')});
      txtadd(markerName, 'markerPrev_', get(currentObjectId));
      replace_marker_url(%markerName, ${require('../img/button/left-disable.png')});
    );
    if (haveGallery ,
      txtadd(markerName, 'markerScaleUp_', get(currentObjectId));
      replace_marker_url(%markerName, ${require('../img/button/plus-default.png')});
      txtadd(markerName, 'markerScaleDown_', get(currentObjectId));
      replace_marker_url(%markerName, ${require('../img/button/minus-default.png')});
    );
  </action>
`

export const setGalleryScaleXml = `
  if (haveMultiImages,
    txtadd(markerName, 'markerNext_', get(currentObjectId));
    set_marker_scale_html(get(markerName), 1, null);

    txtadd(markerName, 'markerPrev_', get(currentObjectId));
    set_marker_scale_html(get(markerName), 1, null);
  );
  if (haveGallery ,
    for (set(i, 0), i LT imagesLength, inc(i),
      txtadd(markerName, 'markerInfoImage_', get(i), '_', get(currentObjectId));
      set_marker_scale_html(get(markerName), 1, null);
      if (get(i) == 0,
        set(hotspot[%markerName].alpha, 1);
      ,
        set(hotspot[%markerName].alpha, 0);
      );
    );

    txtadd(markerName, 'markerScaleUp_', get(currentObjectId));
    set_marker_scale_html(get(markerName), 1, null);
    txtadd(markerName, 'markerScaleDown_', get(currentObjectId));
    set_marker_scale_html(get(markerName), 1, null);
  );
`
export const setGalleryPositionXml = `
  if (haveMultiImages,
    txtadd(markerName, 'markerNext_', get(currentObjectId));
    set_marker_position(get(markerName) ,get(ath), get(atv));

    txtadd(markerName, 'markerPrev_', get(currentObjectId));
    set_marker_position(get(markerName) ,get(ath), get(atv));
  );
  if (haveGallery ,
    for (set(i, 0), i LT imagesLength, inc(i),
      txtadd(markerName, 'markerInfoImage_', get(i), '_', get(currentObjectId));
      set_marker_position(get(markerName) ,get(ath), get(atv));
    );
    txtadd(markerName, 'markerScaleUp_', get(currentObjectId));
    set_marker_position(get(markerName) ,get(ath), get(atv));

    txtadd(markerName, 'markerScaleDown_', get(currentObjectId));
    set_marker_position(get(markerName) ,get(ath), get(atv));
  );
`

const mouseHoverXml = `
  <action name="prev_onover" scope="local" args="markerName">
    if (currentGalleryIndex == 0, exitcall());
    set(tempName, get(markerName));
    replace_marker_url(%tempName, ${require('../img/button/left-hover.png')});
  </action>

  <action name="next_onover" scope="local" args="markerName">
    if (currentGalleryIndex == imagesLength - 1, exitcall());
    set(tempName, get(markerName));
    replace_marker_url(%tempName, ${require('../img/button/right-hover.png')});
  </action>

  <action name="scaleUp_onover" scope="local" args="markerName">
    if (currentImageScale GE maxScale, exitcall());
    set(tempName, get(markerName));
    replace_marker_url(%tempName, ${require('../img/button/plus-hover.png')});
  </action>

  <action name="scaleDown_onover" scope="local" args="markerName">
    if (currentImageScale LE minScale, exitcall());
    set(tempName, get(markerName));
    replace_marker_url(%tempName, ${require('../img/button/minus-hover.png')});
  </action>


`
const mouseOutXml = `
  <action name="prev_onout" scope="local" args="markerName">
    set(tempName, get(markerName));
    if (currentGalleryIndex GT 0,
      replace_marker_url(%tempName, ${require('../img/button/left-default.png')});
    ,
      replace_marker_url(%tempName, ${require('../img/button/left-disable.png')});
    );
  </action>
  <action name="next_onout" scope="local" args="markerName">
    set(tempName, get(markerName));
    if (currentGalleryIndex LT imagesLength - 1,
      replace_marker_url(%tempName, ${require('../img/button/right-default.png')});
    ,
      replace_marker_url(%tempName, ${require('../img/button/right-disable.png')});
    );
  </action>
  <action name="scaleUp_onout" scope="local" args="markerName">
    set(tempName, get(markerName));
    if (currentImageScale LT maxScale,
      replace_marker_url(%tempName, ${require('../img/button/plus-default.png')});
    ,
      replace_marker_url(%tempName, ${require('../img/button/plus-disable.png')});
    );
  </action>
  <action name="scaleDown_onout" scope="local" args="markerName">
    set(tempName, get(markerName));
    if (currentImageScale GT minScale,
      replace_marker_url(%tempName, ${require('../img/button/minus-default.png')});
    ,
      replace_marker_url(%tempName, ${require('../img/button/minus-disable.png')});
    );
  </action>

`
const mouseClickXml = `

  <action name="disable_button_when_click">
    set(enableClickButton, false);
  </action>

  <action name="enable_button_until_time_up">
    set(enableClickButton, true);
  </action>

  <action name="get_notFirstImage">
    if (currentGalleryIndex !== 0,
        set(notFirstImage, true);
      ,
        set(notFirstImage, false);
    );
  </action>

  <action name="get_notLastImage">
    if (currentGalleryIndex !== calc(imagesLength - 1),
        set(notLastImage, true);
      ,
        set(notLastImage, false);
    );
  </action>

  <action name="prev_onclick" scope="local" args="objectId">
    get_notFirstImage();

    if (notFirstImage AND enableClickButton,
      disable_button_when_click();

      txtadd(markerName, 'markerPrev_', get(objectId));
      replace_marker_url(get(markerName), ${require('../img/button/left-select.png')});

      delayedcall(.3,
        moving_image("prev", get(objectId), "invisible");
        set(currentGalleryIndex, calc(currentGalleryIndex - 1));
        moving_image("prev", get(objectId), "visible");

        if (currentGalleryIndex == 0,
          txtadd(markerName, 'markerPrev_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/left-disable.png')});
          txtadd(markerName, 'markerNext_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/right-default.png')});
        ,
          txtadd(markerName, 'markerPrev_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/left-hover.png')});
          txtadd(markerName, 'markerNext_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/right-default.png')});
        );
        enable_button_until_time_up();
      );
    );
  </action>

  <action name="next_onclick" scope="local" args="objectId">
    get_notLastImage();

    if (notLastImage AND enableClickButton,
      disable_button_when_click();

      txtadd(markerName, 'markerNext_', get(objectId));
      replace_marker_url(get(markerName), ${require('../img/button/right-select.png')});

      delayedcall(.3,
        moving_image("next", get(objectId), "invisible");
        set(currentGalleryIndex, calc(currentGalleryIndex + 1));
        moving_image("next", get(objectId), "visible");

        if (currentGalleryIndex == imagesLength - 1,
          txtadd(markerName, 'markerNext_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/right-disable.png')});
          txtadd(markerName, 'markerPrev_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/left-default.png')});
        ,
          txtadd(markerName, 'markerNext_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/right-hover.png')});
          txtadd(markerName, 'markerPrev_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/left-default.png')});
        );
        enable_button_until_time_up();
      );
    );
  </action>

  <action name="moving_image" scope="parent">
    txtadd(markerName, 'markerInfoImage_', get(currentGalleryIndex),'_', %2);
    set(img_width, get(hotspot[%markerName].width));
    set(img_ox, get(hotspot[%markerName].ox));
    set(currentImageScale, 1); <!-- reset image scale -->
    if (%1 == 'next',
      tween(hotspot[%markerName].ox, calc(img_ox - img_width), .5);
    );
    if (%1 == 'prev',
      tween(hotspot[%markerName].ox, calc(img_ox + img_width), .5);
    );
    if (%3 == 'visible',
        tween(hotspot[%markerName].alpha, 1, .5);
    );
    if (%3 == 'invisible',
        tween(hotspot[%markerName].alpha, 0, .5);
    );
  </action>

  <action name="get_notLargestScale" scope="local">
    set(local.calcScale, calc(currentImageScale + scaleGap));
    roundval(calcScale, 1);
    if (number(calcScale) LE maxScale,
        set(notLargestScale, true);
      ,
        set(notLargestScale, false);
    );
  </action>

  <action name="get_notSmallestScale" scope="local">
    set(local.calcScale, calc(currentImageScale - scaleGap));
    roundval(calcScale, 1);

    if (number(calcScale) GE minScale,
        set(notSmallestScale, true);
      ,
        set(notSmallestScale, false);
    );
  </action>

  <action name="scale_up_onclick" scope="local" args="objectId">
    get_notLargestScale();

    if (notLargestScale AND enableClickButton,
      disable_button_when_click();

      txtadd(markerName, 'markerScaleUp_', get(objectId));
      replace_marker_url(get(markerName), ${require('../img/button/plus-select.png')});

      delayedcall(.3,
        txtadd(markerName, 'markerInfoImage_', get(currentGalleryIndex), '_', get(objectId));
        set(currentImageScale, calc(currentImageScale + scaleGap));
        tween(hotspot[%markerName].scale, get(currentImageScale), .5);

        if (currentImageScale GE maxScale,
          txtadd(markerName, 'markerScaleUp_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/plus-disable.png')});
        ,
          txtadd(markerName, 'markerScaleUp_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/plus-hover.png')});
          txtadd(markerName, 'markerScaleDown_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/minus-default.png')});
        );
        enable_button_until_time_up();
      );
    );
  </action>

  <action name="scale_down_onclick" scope="local" args="objectId">
    get_notSmallestScale();

    if (notSmallestScale AND enableClickButton,
      disable_button_when_click();

      txtadd(markerName, 'markerScaleDown_', get(objectId));
      replace_marker_url(get(markerName), ${require('../img/button/minus-select.png')});

      delayedcall(.3,
        txtadd(markerName, 'markerInfoImage_', get(currentGalleryIndex), '_', get(objectId));
        set(currentImageScale, calc(currentImageScale - scaleGap));
        tween(hotspot[%markerName].scale, get(currentImageScale), .5);

        if (currentImageScale LE minScale,
          txtadd(markerName, 'markerScaleDown_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/minus-disable.png')});
        ,
          txtadd(markerName, 'markerScaleDown_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/minus-hover.png')});
          txtadd(markerName, 'markerScaleUp_', get(objectId));
          replace_marker_url(get(markerName), ${require('../img/button/plus-default.png')});
        );
        enable_button_until_time_up();
      );
    );
  </action>
`
export const setGalleryButtonsEventsXml = `
  ${mouseHoverXml}
  ${mouseOutXml}
  ${mouseClickXml}
`
